// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'
import { EmployeeTimeManagementAreaId } from './EmployeeTimeManagementAreaId'

const baseRoute = '/employee-time-management'

export const EmployeeTimeManagementAreaRoutes = transformRoutes({
  route: baseRoute,
  title: `${EmployeeTimeManagementAreaId}:Title`,
})
